<template>
    <div >
      <b-row>
          <b-col md="12">
             <MdTitle v-bind:Text="$t('DrugIssuedByMonthRep.ReportTitle')" />
          </b-col>
      </b-row>
      <b-row>
          <div class="col-sm-12 col-md-12 mb-4">
              <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                  <div class="input-group"  dir="ltr">
                      <input type="text" class="form-control" v-model="parameter.SearchCriteria"
                          @keyup.enter="LoadDrugIssuedByMonth" />

                      <div class="input-group-append">
                          <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                              v-bind:IconClass="'mdi mdi-magnify'" v-on:click="LoadDrugIssuedByMonth">
                          </MdButton>
                      </div>
                  </div>
              </div>
          </div>
      </b-row>
      <b-row>
          <b-col lg="3" md="3" sm="12">
            <!--<MdEdit 
              v-bind:Label="$t('Shared.datefrom')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'datefrom'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateFrom"
              v-bind:isRequired="false">                                     
            </MdEdit>-->
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'DrugIssuedByMonthRepDateFrom'"
              :Type="'date'"  
              :OnPressEnter="LoadDrugIssuedByMonth"            
              :isRequired="false"                           
              :isConfirm="false"
              :ReadOnly="false">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <!--<MdEdit 
              v-bind:Label="$t('Shared.dateTo')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'dateto'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateTo"
              v-bind:isRequired="false">                                     
            </MdEdit>-->
            <MdDateTime 
              :Label="$t('Shared.dateTo')" 
              :Model="dateTo"                           
              @input="dateTo = $event"                            
              :Id="'DrugIssuedByMonthRepDateTo'"
              :OnPressEnter="LoadDrugIssuedByMonth"    
              :Type="'date'"             
              :isRequired="false"                           
              :isConfirm="false"
              :ReadOnly="false">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$t('Medication.Drugs')"
              v-bind:Options="DrugList"
              v-bind:Model="DrugsCodeModel"
              v-bind:FieldDescription="'drugname'"
              v-bind:FieldCode="'drugCode'"
              v-bind:Multiple="true"             
              :Input="ChangeDrugs"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$tc('ePharmacyItemsReceived.Location')"
                v-bind:Options="LocList"
                v-bind:Model="LocCodeModel"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'" 
                v-bind:Multiple="true"                      
                :Input="ChangeLocation"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.DrugType')"
              v-bind:Options="DrugTypeList"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Multiple="true"
              v-bind:Model="DrugTypeModel"  
              :Input="ChangeDrugType"/>
          </b-col>
          <b-col lg="9" md="9" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadDrugIssuedByMonth"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col> 
     
        </b-row>
        <div class="row">
          <div class="col-12 mt-2">
             <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

            <div class="row">
              <div class="col-md-12">
               
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
              </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>

          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   
        </div>

      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('DrugIssuedByMonthRep.ReportTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportDrugIssuedByMonthFilters"
          :ReportName="'DrugIssuedByMonth'"
          :ReportTitle="$t('DrugIssuedByMonthRep.ReportTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('DrugIssuedByMonthRep.ReportTitle')"
        v-bind:sendEmailAPI="'/Utils/sendEmail'"
        v-bind:exportCsvAPI="'/DrugIssuedByMonth/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import PharmacyRepFunctions from '@/common/PharmacyRepFunctions.js'
  import UtilsService from '@/services/utils.service'
  import { EventBus } from '@/event-bus.js';
  

  export default Vue.extend({
      name: "DrugIssuedByMonthRep",
      mixins: [ ShowMessage, DBFunctions, PharmacyRepFunctions ],
      components: { DxPopup },
      data() {
          return {
              isParamVisible: true,
              isReportVisible: false,
              dateFrom: null,
              dateTo:null,
              lots: '',
              reportParams: [],
              DrugList:[],
              DrugsCodeModel:'',
              LocCodeModel:'',
              LocList:[],
              parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0       
              },
              params: {
                DrugList: '',
                LocList: '',
                DrugType: ''
              },
              DrugTypeModel: '',
              DrugTypeList: [],
              items: [],         
              fields: [
                { key: 'DrugCode', sortable: true, label: this.$t('drug.DrugCode'), class: 'text-left' },
                { key: 'DrugName', sortable: true, label: this.$t('drug.Drugname'), class: 'text-left' },
                { key: 'YearTransDate', sortable: true, label: this.$t('DrugIssuedByMonthRep.YearTransDate'), class: 'text-center' },
                { key: 'LocationFrom', sortable: true, label: this.$t('DrugIssuedByMonthRep.LocationFrom'), class: 'text-left' },
                { key: 'JAN_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.January'), class: 'text-left' },
                { key: 'FEB_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.February'), class: 'text-left' },
                { key: 'MAR_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.March'), class: 'text-left' },
                { key: 'APR_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.April'), class: 'text-left' },
                { key: 'MAY_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.May'), class: 'text-left' },
                { key: 'JUN_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.June'), class: 'text-left' },
                { key: 'JUL_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.July'), class: 'text-left' },
                { key: 'AUG_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.August'), class: 'text-left' },
                { key: 'SEP_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.September'), class: 'text-left' },
                { key: 'OCT_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.October'), class: 'text-left' },
                { key: 'NOV_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.November'), class: 'text-left' },
                { key: 'DEC_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.December'), class: 'text-left' }
              ],
              pageOptions: [5, 10, 15 ],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              selected: [],
              Header:{},
              refTable: 'selectableTable', 
              ShowMessageIsEmpty:true,
              FieldsDateArr:['dateFrom','dateTo'],  
          }
      },
      methods: {

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
          },

          onClickClose() {
            this.isParamVisible = false;
          },

          reportList() {
            this.checkExistFavorite('/app/reports/pharmacy');
            this.$router.push({ name: "reportListPharmacy" }).catch(()=>{});
          },

          initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
            this.reportParams.push({ paramName: 'pDrogList',paramValue: this.params.DrugList })
            this.reportParams.push({ paramName: 'pLocList',paramValue: this.params.LocList })
            this.reportParams.push({ paramName: 'pDrugType', paramValue: this.params.DrugType})
            this.reportParams.push({ paramName: 'rSearchCriteria', paramValue: this.parameter.SearchCriteria})
            this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})
          },

          onClickShowReport() {
            this.isParamVisible = false
            this.initializePdfParameters();
            this.isReportVisible = true
            this.$refs.reportDrugIssuedByMonthFilters.buildDocument(this.reportParams)
          },

          LoadDrugIssuedByMonth() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getListing();
          },

          initializeParameters() {
           
            // Asignaciones condicionales
            this.parameter.DateFrom = this.dateFrom;
            this.parameter.DateTo = this.dateTo;
                       this.parameter.DrugList = this.params.DrugList && this.params.DrugList !== '' 
                ? this.params.DrugList 
                : null;
            
            this.parameter.DrugType = this.params.DrugType && this.params.DrugType !== '' 
              ? this.params.DrugType
              : null;
           
            this.parameter.LocList = this.params.LocList && this.params.LocList !== '' 
              ? this.params.LocList
              : null;
          },

          getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            const procedureName = 'sp_iss_LetterTemplateDrugIssuedByMonthMultSelection'; 
            this.initializeParameters();

            const spParameters = {
                SearchCriteria: this.parameter.SearchCriteria,
                DrugCode: this.parameter.DrugList,
                IsControlledSubstance: this.parameter.DrugType,
                LocationFrom: this.parameter.LocList,
                DateFrom: this.parameter.DateFrom,
                DateTo: this.parameter.DateTo,
            };
            
            const request = {
                procedureName: procedureName,
                parameters: spParameters,
                pageNumber: this.parameter.PageNumber,
                pageSize: this.parameter.PageSize
            };
          
            UtilsService.getExecuteSP(request)
              .then(response => {
                  if (response.status == "200" && response.data) {
                      this.items = response.data;

                      let headerString = response.headers["x-pagination"];
                      this.Header = JSON.parse(headerString);
                      this.totalRows = this.Header.TotalCount;
                      this.showEmptyRecords = response.data && response.data.length == 0 ? true : false
                      this.$emit('showEmptyRecords', this.showEmptyRecords);
                  }
              })
              .catch(error => {
                  this.showResponseErrorMessage(error);
              });
          },

          pageChanged (page) {            
            this.currentPage = page;
            this.getListing();    
          },

          PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();
          },

          handleCSV(action) {
            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          handlePdf(action) {
            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf('DrugIssuedByMonth', true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf('DrugIssuedByMonth', true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          validate_required(){
            const IsValidDateFrom = this.dateFrom ? true : false;
            const IsValidDateTo = this.dateTo ? true : false;
            return IsValidDateFrom  &&  IsValidDateTo; 
        },
      },
      
      mounted () {
        this.getDrugsFilter();
        this.getLocationsFilter();
        this.getDrugTypeFilter();

        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
      },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
